const isCoUk = () => window.location.hostname.endsWith('.co.uk');

export const contactEmail = () => isCoUk() ? 'contact@ddhapps.co.uk' : 'contact@ddhapps.com';
